<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row>
              <v-col cols="12" md="8">
                <h1 class="headline">
                  Daftar Penilaian Esai
                  <span class="info--text">
                    {{ jenis === 'kasek' ? 'Kepala Sekolah' : 'Fasilitator' }}
                  </span>
                </h1>
                <p>Daftar Esai Kandidat yang telah diisikan oleh para Kandidat</p>
              </v-col>
            </v-row>
            <v-row style="border-top: 1px solid rgba(0, 0, 0, 0.12)">
              <v-col cols="12" md="8" sm="12">
                <template v-if="jadwal[jenis]">
                  <v-icon left>mdi-alert-circle</v-icon> Jadwal Penilaian Esai<br />
                  <div class="ml-5 px-3">
                    <b v-html="jadwal[jenis]"></b>
                  </div>
                </template>
              </v-col>
              <v-col cols="12" md="4" sm="12" class="text-md-right">
                <template v-if="isAsesor && $isObject(pemantau)">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list
                        dense
                        two-line
                        outlined
                        class="mb-2 pa-0 yellow"
                        :style="{ marginTop: '0px', borderRadius: '5px' }"
                      >
                        <v-list-item dense v-bind="attrs" v-on="on">
                          <v-list-item-icon class="mb-2">
                            <v-icon color="indigo" size="32">mdi-account-search</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content class="text-left indigo--text">
                            <h4>{{ (pemantau && pemantau.nama) || '-' }}</h4>
                            <h5>
                              {{ (pemantau && pemantau.no_hp) || '-' }}
                              <v-icon
                                v-if="pemantau && pemantau.no_hp"
                                color="success"
                                small
                                dark
                                @click="onCall(pemantau.no_hp)"
                              >
                                mdi-whatsapp
                              </v-icon>
                            </h5>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                    <span>Pemantau Asesor</span>
                  </v-tooltip>
                </template>
                <template v-if="$allow(`psp-${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-esai.kinerja`)">
                  <v-btn color="pink" dark @click="onKinerja">
                    <v-icon left>mdi-text-box-check</v-icon> laporan kinerja
                  </v-btn>
                </template>
                <template v-if="$allow(`psp-${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-esai.kinerja-asesor`)">
                  <v-btn class="mt-1" color="pink" dark @click="onKinerjaAsesor">
                    <v-icon left>mdi-text-box-check</v-icon> laporan kinerja Asesor
                  </v-btn>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <statistik :value="stats" :jenis="jenis" :isAsesor="isAsesor"></statistik>
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          btn-filter
          :btnDownload="$allow(`psp-${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-esai.download`)"
          @reload="onReload"
          @filter="onFilter"
          @download="onDownload"
          :searchInput="false"
        >
          <template v-slot:toolbar>
            <v-text-field
              v-model="keyword"
              label="Cari Kandidat"
              v-mask="'######'"
              dense
              single-line
              outlined
              hide-details
              class="mt-1 mr-1"
              @keyup.enter="search"
              @click:append="search"
            >
            </v-text-field>
            <v-select
              class="mt-7 mx-1"
              v-model="params.gelombang"
              :items="mGelombang"
              item-text="text"
              item-value="value"
              dense
              outlined
              @change="onReload"
              style="max-width: 180px"
            />
          </template>
          <template v-slot:subtitle>
            <div class="body-1">Daftar Esai Kandidat <span class="blue--text" v-text="total" /> </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider></v-divider>
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterSave"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" :md="isPusat ? 3 : 4">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-account-circle</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0">
                          <h2 class="body-1 blue-grey--text text--darken-2">
                            Kandidat {{ $getDeepObj(item, 'id') }}
                          </h2>
                          <template v-if="$isObject(lockedData(item))">
                            <span class="caption grey--text">Asesor: </span>
                            <span class="black--text">
                              {{ $getDeepObj(lockedData(item), 'akun.data.nama') || '-' }}
                            </span>
                          </template>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0" v-if="Number(item && item.k_proses_nilai_esai_psp) > 1">
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="caption grey--text">
                            Tanggal {{ Number(item && item.k_proses_nilai_esai_psp) === 3 ? 'Penilaian' : 'Kunci' }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            {{
                              Number(item && item.k_proses_nilai_esai_psp) === 3
                                ? $localDate($getDeepObj(NilaiData(item), 'wkt_proses')) || '-'
                                : $localDate($getDeepObj(lockedData(item), 'wkt_proses')) || '-'
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2" v-if="isPusat">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="caption grey--text">
                            Pemantau
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            {{
                              $getDeepObj(
                                item,
                                'psp_profil_proseses.data.0.akun.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.nama'
                              )
                            }}
                            <br />
                            {{
                              $getDeepObj(
                                item,
                                'psp_profil_proseses.data.0.akun.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_hp'
                              ) || '-'
                            }}
                            <v-icon
                              v-if="
                                $getDeepObj(
                                  item,
                                  'psp_profil_proseses.data.0.akun.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_hp'
                                )
                              "
                              color="success"
                              small
                              dark
                              @click="
                                onCall(
                                  $getDeepObj(
                                    item,
                                    'psp_profil_proseses.data.0.akun.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_hp'
                                  )
                                )
                              "
                            >
                              mdi-whatsapp
                            </v-icon>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="caption grey--text" v-text="'Status Penilaian'"></v-list-item-title>
                          <div class="mx-auto">
                            <v-chip
                              small
                              :color="Number(item && item.k_proses_nilai_esai_psp) === 3 ? 'green' : 'red'"
                              dark
                            >
                              {{
                                Number(item && item.k_proses_nilai_esai_psp) === 3 ? 'Sudah dinilai' : 'Belum dinilai'
                              }}
                            </v-chip>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Aksi Selanjutnya</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-btn
                              color="primary"
                              small
                              dark
                              @click="onKunci(item)"
                              v-if="
                                $allow(
                                  `psp-${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-esai.kunci`,
                                  item.policies
                                ) && !$isObject(lockedData(item))
                              "
                              min-width="200"
                            >
                              KUNCI BERKAS
                            </v-btn>
                            <v-btn
                              v-else-if="
                                $allow(`psp-${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-esai.save`, item.policies)
                              "
                              color="primary"
                              small
                              dark
                              @click="onNilai(item)"
                              min-width="200"
                            >
                              {{ Number(item && item.k_proses_nilai_esai_psp) === 3 ? 'Lihat Detail' : 'Nilai Esai' }}
                            </v-btn>
                            <v-btn v-else color="primary" small dark @click="onNilai(item)" min-width="200">
                              Lihat Detail
                            </v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <base-list-action :data="item" :actions="actions[jenis]" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <!-- modal form -->
    <base-modal-full
      ref="modal"
      title="Pemeriksaan Data Esai"
      :useSave="formulir.isPreview ? false : !formulir.isDisable"
      @save="onSave"
    >
      <form-nilai
        ref="formulir"
        generalError
        :esais="formulir.esais"
        :initValue="formulir.init"
        :type="formulir.type"
        :isPreview="formulir.isPreview"
        :angkatan="params.angkatan"
        :isDisable="formulir.isDisable"
        :detail="formulir.detail"
      ></form-nilai>
    </base-modal-full>
    <base-modal-full ref="kinerja" title="Laporan Kinerja" :useSave="false">
      <form-kinerja
        ref="formkinerja"
        title="Penilaian Esai"
        :akun="akun"
        :useDownload="formulir.useDownload"
        :isPusat="isPusat"
        :jenis="jenis"
        :angkatan="params.gelombang"
        @download="onUnduhKinerja"
      ></form-kinerja>
    </base-modal-full>
  </div>
</template>

<script>
import list from '@mixins/list';
import { mapActions, mapState } from 'vuex';
import FormNilai from '../formulir/PenilaianEsai';
import Actions from './actions';
import Statistik from '../component/Statistik';
import configs from './configs';
import FormKinerja from '../component/Kinerja';

export default {
  name: 'PenilaianEsai',
  mixins: [list],
  components: { Statistik, FormNilai, FormKinerja },
  data() {
    return {
      actions: Actions,
      keyword: '',
      formulir: {},
      stats: {},
      detail: {},
      listAsesor: [],
      jenis: '',
      pemantau: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      akun: (state) => Object.assign({}, state.data.akun),
      groups: (state) => state.data && state.data.groups,
      pspConfig: (state) => (state.data && state.data.config) || {},
    }),

    jadwal() {
      return {
        kasek: this.$durasi(
          this.$getDeepObj(this.pspConfig, `peserta.esai.${this.params.gelombang}.wkt_mulai_verval`),
          this.$getDeepObj(this.pspConfig, `peserta.esai.${this.params.gelombang}.wkt_selesai_verval`)
        ),
        instruktur: this.$durasi(
          this.$getDeepObj(this.pspConfig, `pelatih_ahli.esai.${this.params.gelombang}.wkt_mulai_verval`),
          this.$getDeepObj(this.pspConfig, `pelatih_ahli.esai.${this.params.gelombang}.wkt_selesai_verval`)
        ),
      };
    },

    isPusat() {
      return Object.keys(this.groups).includes('141');
    },

    isAsesor() {
      const groups = (this.$isObject(this.groups) && Object.keys(this.groups)) || [];
      return groups.includes(`147`) || groups.includes(`148`);
    },

    mapAsesor() {
      let temp = {};
      for (const akun of this.listAsesor) {
        temp[this.$getDeepObj(akun, 'akun.data.akun_id')] = this.$getDeepObj(akun, 'akun.data.nama');
      }
      return temp;
    },

    formFilter() {
      let form = [];
      let master = Object.assign({}, this.masters.proses_nilai_psp);
      // hapus master 1 dan 2
      delete master[1];
      delete master[4];

      form.push({
        label: 'Pilih Status Esai',
        default: true,
        type: 'checkbox',
        model: 'k_proses_nilai_esai_psp',
        master: this.$mapForMaster(master),
        props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
        grid: { cols: 12, md: 6 },
      });

      if (this.listAsesor && this.listAsesor.length) {
        form.push({
          label: 'Pilih Asesor',
          model: 'akun_id',
          type: 'select',
          props: ['attach'],
          master: this.$mapForMaster(this.mapAsesor),
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        });
      }

      return form;
    },

    filtersMaster() {
      return {
        k_proses_nilai_esai_psp: this.masters['proses_nilai_psp'],
        akun_id: this.mapAsesor,
      };
    },

    mGelombang() {
      const jenis = this.jenis === 'kasek' ? 'peserta' : 'pelatih_ahli';
      const result = [];

      for (let i = Number(this.pspConfig[jenis]['gelombang']); i > 0; i--) {
        result.push({ text: `Angkatan ${i}`, value: i });
      }

      return result;
    },
  },
  created() {
    this.jenis = this.$route.meta.jenis || 'kasek';
    this.$set(
      this.params,
      'gelombang',
      this.$getDeepObj(this, `pspConfig.${this.jenis === 'kasek' ? 'peserta' : 'pelatih_ahli'}.gelombang`)
    );

    this.getMasters('proses_nilai_psp');
    this.getAsesor({ jenis: this.jenis }).then(({ data }) => {
      this.listAsesor = data;
    });

    this.onStatatistik();
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('penilaian', [
      'fetch',
      'getStatistik',
      'getDetail',
      'action',
      'getKinerja',
      'getAsesor',
      'downloadList',
      'unduhKinerja',
    ]),

    onReload() {
      this.fetchData();
      this.onStatatistik();
    },

    onStatatistik() {
      this.getStatistik({
        jenis: this.jenis,
        params: { gelombang: this.$getDeepObj(this, 'params.gelombang') || 1 },
      }).then((data) => {
        this.stats = this.$isObject(data) ? data : {};
      });
    },

    fetchData: function() {
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        this.fetch({ params, jenis: this.jenis }).then(({ data, meta }) => {
          this.data = data || [];
          this.total = meta?.total || 0;
          this.pageTotal = meta?.last_page || 1;
          this.params.limit = meta?.per_page || this.params.limit;
          this.statistik = meta?.statistik || {};
          this.pemantau = meta?.pemantau || {};
          resolve(true);
        });
      });
    },

    search() {
      this.onSearch(this.keyword);
    },

    lockedData(item) {
      const proses = this.$getDeepObj(item, 'psp_profil_proseses.data') || [];
      const data = proses.filter((item) => item.k_profil_proses_psp === 10)[0];
      return data;
    },

    NilaiData(item) {
      const proses = this.$getDeepObj(item, 'psp_profil_proseses.data') || [];
      const data = proses.filter((item) => item.k_profil_proses_psp === 11)[0];
      return data;
    },

    async onNilai(data) {
      this.id = data.id;
      const detail = await this.getDetail({ id: this.id, jenis: this.jenis }).then(({ data }) => data);
      const esais = this.$getDeepObj(detail, 'psp_profil_esais.data') || [];
      const angkatan = this.$getDeepObj(detail, 'gelombang') || 1;
      const policies = (data && data.policies) || {};
      const isEdit =
        this.$allow(`psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-esai.save`, policies) &&
        this.$getDeepObj(detail, 'k_proses_nilai_esai_psp') < 3;

      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'detail', null);
      this.$set(this.formulir, 'angkatan', angkatan);
      this.$set(this.formulir, 'isDisable', !isEdit);
      this.$set(this.formulir, 'esais', esais);
      this.$set(this.formulir, 'isPreview', !isEdit);
      this.$set(this.formulir, 'type', this.jenis);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        const value = this.$getDeepObj(detail, 'psp_profil_nilais.data');
        this.$set(this.formulir, 'detail', detail);
        this.$set(this.formulir, 'init', value);
      });
    },

    onSave() {
      const rubrik = this.$getDeepObj(configs.rubriks, `${this.formulir.type}.1`) || [];
      const mapRubrikId = rubrik.map((item) => item.id);
      let kosong = false;
      let params = [];

      for (const key of mapRubrikId) {
        const nilai = this.$refs.formulir.form[key];
        if (!kosong && [null, '', undefined].includes(nilai)) {
          kosong = true;
          break;
        }
        params.push({
          k_profil_rubrik_psp: key,
          nilai: Number(nilai),
        });
      }

      if (kosong) {
        this.$refs.modal.loading = false;
        this.$error('Pastikan Anda telah mengisi semua kolom input penilaian.');
        return;
      }

      this.action({
        id: this.id,
        jenis: this.jenis,
        type: 'save',
        params: {
          nilais: params,
          catatan: this.$refs.formulir.form['catatan'] || '',
        },
      })
        .then(() => {
          this.onReload();
          this.$success('Nilai berhasil disimpan');
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onKunci(data) {
      this.id = data.psp_profil_id;
      this.$confirm(`Anda yakin ingin mengunci Esai Kandidat di atas agar bisa dinilai?`, `Kunci Esai`, {
        tipe: 'warning',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: this.id, type: 'kunci', jenis: this.jenis }).then(() => {
          this.$success(`Esai Kandidat berhasil dikunci`);
          this.onReload();
        });
      });
    },

    onBatalKunci(data) {
      this.$confirm(`Anda yakin ingin membatalkan Kunci Esai Kandidat di atas?`, `Batal Kunci Esai`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.psp_profil_id, type: 'batal-kunci', jenis: this.jenis }).then(() => {
          this.$success(`Batal kunci Esai Kandidat berhasil`);
          this.onReload();
        });
      });
    },

    onBatalNilai(data) {
      this.$confirm(`Anda yakin ingin membatalkan Penilaian Esai kandidat di atas?`, `Batal Penilaian`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.psp_profil_id, type: 'reset', jenis: this.jenis }).then(() => {
          this.$success(`Batal Penilaian Esai Kandidat berhasil`);
          this.onReload();
        });
      });
    },

    confirmHtml(data) {
      return [
        {
          icon: 'mdi-account-circle',
          iconSize: 60,
          iconColor: 'secondary',
          title: `Kandidat ${data.id}`,
          subtitles: '',
        },
      ];
    },

    async onKinerja() {
      const params = {
        tipe: 'esai',
        jenis: this.jenis,
        gelombang: this.params.gelombang,
      };

      const resp = await this.getKinerja(params);
      const nilais = (resp && resp.data) || [];
      const statistik = {};
      const limit = Number(this.$getDeepObj(resp, 'meta.total')) || 0;

      const items = nilais.map((key, index) => {
        const pemantau = this.$getDeepObj(key, 'psp_pemantau_asesor_asesor.data.akun_pemantau.data') || {};
        return {
          no: index + 1,
          nama: `<p class="my-1">${key.nama}<br/><span class="">${key.no_hp}</span></p>`,
          diproses: key.diproses,
          dinilai: key.dinilai,
          pemantau: this.$isObject(pemantau)
            ? `<p class="my-1">${(pemantau && pemantau.nama) || '-'}<br/><span class="">${(pemantau &&
                pemantau.no_hp) ||
                '-'}</span></p>`
            : '',
          jumlah: Number(key.diproses) + Number(key.dinilai),
        };
      });

      const headers = [
        {
          text: 'NO',
          align: 'start',
          sortable: false,
          value: 'no',
        },
        { text: 'Asesor', value: 'nama' },
        { text: 'Belum Dinilai', value: 'diproses' },
        { text: 'Dinilai', value: 'dinilai' },
        { text: 'Jumlah', value: 'jumlah' },
      ];

      if (this.isPusat) {
        headers.splice(2, 0, { text: 'Pemantau Asesor', value: 'pemantau' });
      }

      this.$set(
        this.formulir,
        'useDownload',
        this.$allow(`psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-esai.kinerja-download`)
      );
      this.$set(this.formulir, 'laporan', 'kinerja/download');

      this.$refs.kinerja.open();

      this.$nextTick(() => {
        this.$refs.formkinerja.reset();
        this.$refs.formkinerja.headers = headers;
        this.$refs.formkinerja.data = (resp && resp.nilais) || [];
        this.$refs.formkinerja.items = items || [];
        this.$refs.formkinerja.kinerja = (resp && resp.kinerja) || null;
        this.$refs.formkinerja.statistik = statistik;
        this.$refs.formkinerja.limit = limit;
      });
    },

    async onKinerjaAsesor() {
      const payload = {
        params: {
          count: 200,
          gelombang: this.params.gelombang,
        },
        jenis: this.jenis,
      };

      const resp = await this.fetch(payload);
      const nilais = (resp && resp.data) || [];
      const statistik = {
        belum_dinilai: this.$getDeepObj(this.stats, '2'),
        sudah_dinilai: this.$getDeepObj(this.stats, '3'),
      };
      const limit = Number(this.$getDeepObj(resp, 'meta.total')) || 0;

      const items = nilais.map((key, index) => {
        return {
          no: index + 1,
          nama: `<p class="my-1">KANDIDAT ${this.$getDeepObj(key, 'psp_profil_id') || ''}</p>`,
          status: this.masters['proses_nilai_psp'][key.k_proses_nilai_esai_psp] || '',
          wkt_nilai:
            Number(key && key.k_proses_nilai_esai_psp) === 3
              ? this.$localDate(this.$getDeepObj(this.NilaiData(key), 'wkt_proses'), true, true) || '-'
              : this.$localDate(this.$getDeepObj(this.lockedData(key), 'wkt_proses'), true, true) || '-',
        };
      });

      const headers = [
        {
          text: 'NO',
          align: 'start',
          sortable: false,
          value: 'no',
        },
        { text: 'Kandidat', value: 'nama' },
        { text: 'Status', value: 'status' },
        { text: 'Waktu Penilaian', value: 'wkt_nilai' },
      ];

      this.$set(
        this.formulir,
        'useDownload',
        this.$allow(`psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-esai.kinerja-asesor`)
      );
      this.$set(this.formulir, 'laporan', 'kinerja-asesor');

      this.$refs.kinerja.open();

      this.$nextTick(() => {
        this.$refs.formkinerja.reset();
        this.$refs.formkinerja.headers = headers;
        this.$refs.formkinerja.data = (resp && resp.nilais) || [];
        this.$refs.formkinerja.items = items || [];
        this.$refs.formkinerja.kinerja = (resp && resp.kinerja) || null;
        this.$refs.formkinerja.statistik = statistik;
        this.$refs.formkinerja.limit = limit;
      });
    },

    onUnduhKinerja() {
      const params = {
        tipe: 'esai',
        laporan: this.formulir.laporan,
        jenis: this.jenis,
      };
      this.unduhKinerja(params).then((url) => {
        window.open(url + `?gelombang=${this.params.gelombang}`, '_blank');
      });
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
